import OfficeBase from './ntko-func-base'

export default class NtkoOffice extends OfficeBase {


  getProduct() {
    return this.ProductType.NTKO_OFFICE;
  }

  /**
   * @param openParams {object} 参数
   * @returns {boolean}
   */
  openDocument(openParams) {

    var openParams = openParams || this.openParams || {};
    var fileId = openParams.fileId || this.fileId || "";
    var formId = openParams.formId || "";
    var businessId = openParams.businessId || "";
    var tempBusinessId = openParams.tempBusinessId || "";
    var xToken = openParams.xToken || this.xToken || "";

    if (fileId && this.downloadUrl) {
      var url = this.downloadUrl + "?id=" + fileId + "&formId=" + formId + "&businessId=" + businessId + "&xToken=" + xToken;
      url += "&tempBusinessId=" + tempBusinessId;
      return this.openFromUrl(url);
    } else {
      return false;
    }
  }

  saveDocumentAsNew(postParams) {
    this.fileLinkId = null;
    return this.saveDocument(postParams);
  }


  /**
   * 保存文档到服务器
   * @returns {*}
   */
  saveDocument(postParams) {
    var me = this;
    var saveParams = postParams || this.saveParams || {};
    // var fileId = saveParams.fileId || this.fileId;
    var formId = saveParams.formId || this.formId || "";
    var businessId = saveParams.businessId || this.businessId || "";
    var tempBusinessId = saveParams.tempBusinessId || this.tempBusinessId || "";
    var xToken = saveParams.xToken || this.xToken || "";
    var efileName = saveParams.fileName || this.fileName || "";
    var efileType = saveParams.efileType || this.efileType || "";
    var attachId = saveParams.attachId || me.fileLinkId || ""

    var params = {
      type: efileType,
      businessId: businessId,
      formId: formId,
      tempBusinessId: tempBusinessId,
      efileName: efileName,
      fileName: efileName,
      xToken: xToken
    }

    if (attachId) {
      params.attachId = attachId;
    }
    postParams = params;
    if (!postParams) {
      return false;
    }
    this.createForm(postParams);
    var saveUrl = postParams.attachId ? this.updateUrl : this.uploadUrl;
    this.log("")
    this.log("postParams: " + JSON.stringify(postParams))
    this.log("saveUrl: " + saveUrl)
    var res = this.ocx.SaveToURL(saveUrl, "uploadFile", "", this.fileName, this.NTKO_SAVE_FORM, false);
    this.log("saveResult=" + res);
    return res;
  }

  saveDocumentToServer() {
    var me = this;
    var extForm = me.form || {};
    var saveParams = this.saveParams || {};
    // var fileId = saveParams.fileId || this.fileId;
    var formId = extForm.formId || saveParams.formId || this.formId || "";
    var businessId = extForm.businessId || saveParams.businessId || this.businessId || "";
    var tempBusinessId = extForm.tempBusinessId || saveParams.tempBusinessId || this.tempBusinessId || "";
    var xToken = saveParams.xToken || this.xToken || "";
    var efileName = saveParams.fileName || this.fileName || "";
    var efileType = saveParams.efileType || this.efileType || "";
    var params = {
      type: efileType,
      businessId: businessId,
      tempBusinessId: tempBusinessId,
      formId: formId
    }

    var res = me.querySync(me.getHttpPath() + PF.url("/api/business/listAttachment"), params);

    // MW.mwApi.business.listAttachment(params).then(function (res) {

    var fileLinkId;
    if (res && res.result && res.result.length > 0) {
      $.each(res.result, function (i, r) {
        if (r.mimeType == ".docx" || r.mimeType == ".doc" || r.mimeType == ".wps") {
          fileLinkId = r.id;
          return true
        }
      })
    }
    if (fileLinkId) {
      me.fileLinkId = fileLinkId;
    } else {
      me.fileLinkId = null;
    }
    var result = me.saveDocument({
      businessId: businessId,
      tempBusinessId: tempBusinessId,
      formId: formId
    });
    var res = JSON.parse(result);
    if (res.result && res.success) {
      if (res.result.fileLinkId) {
        me.fileLinkId = res.result.fileLinkId;
      }
      if (me.form) {
        if (efileType == "JOA_ZW") {
          me.form.setValueByName("fldhaszw", true);
        } else if (efileType == 'JOA_CG') {
          me.form.setValueByName("fldhascg", true);
        } else if (efileType == "JOA_CLD") {
          me.form.setValueByName("fldhascld", true);
        }
      }
      return true;
    } else {
      return false;
    }
    // });
  }


  /**
   * 设置文件名
   * @param {string} fileName 文件名
   */
  setFileName(fileName) {
    this.log("set fileName : " + fileName);
    if (fileName) {
      fileName = fileName.replace(/[\\\/:*?"<>|\n\r]/g, "");
      this.fileName = fileName;
      this.setWebFileName(fileName);
    }
  }

  publishAsPdf(saveParams, isUseSecurity, isPermitPrint, isPermitCopy) {
    var me = this;
    var saveParams = saveParams || this.saveParams || {};
    var formId = saveParams.formId || this.formId || "";
    var businessId = saveParams.businessId || this.businessId || "";
    var tempBusinessId = saveParams.tempBusinessId || this.tempBusinessId || "";
    var xToken = saveParams.xToken || this.xToken || "";
    var efileName = saveParams.fileName || this.fileName || "";
    efileName = this.getBaseName(efileName) + ".pdf";
    var efileType = saveParams.efileType || this.efileType || "";
    var attachId = saveParams.attachId || ""
    if (!me.ocx.IsPDFCreatorInstalled()) {
      alert("请先下载安装PDF转换器后再执行此操作!!");
      return;
    }
    // this.isPublishAsPDFToURLIng = true;

    var params = {
      type: efileType,
      businessId: businessId,
      formId: formId,
      tempBusinessId: tempBusinessId,
      efileName: efileName,
      fileName: efileName,
      xToken: xToken,
      fullPath: "true"
    }
    if (attachId) {
      params.attachId = attachId;
    }
    this.createForm(params);
    var saveUrl = attachId ? this.updateUrl : this.uploadUrl;
    var IsUseSecurity = this.getBoolValue(isUseSecurity, false);
    var IsPermitPrint = this.getBoolValue(isPermitPrint, true);
    var IsPermitCopy = this.getBoolValue(isPermitCopy, true);
    var paramsStr = "";
    me.ocx.PublishAsPDFToURL(saveUrl, "uploadFile", paramsStr, efileName, me.NTKO_SAVE_FORM, "", true, false, IsUseSecurity, me.PASS_WORD, IsPermitPrint, IsPermitCopy);
  }

  /**
   * 插入网络图片
   * @param url {string}
   * @param top {string}
   * @param left {number}
   * @param isSeal {boolean} 是否印章
   */
  addPicFromUrl(url, top, left, isSeal) {
    this.log("imageUrl:" + url);
    var version = this.getOfficeVersion();
    var topx = -50;
    var leftx = 180;
    if (version == this.OfficeVersion.v2003) {
      leftx = 180;
    } else if (version == this.OfficeVersion.v2007) {
      leftx = -40;
    } else if (version == this.OfficeVersion.v2010) {
      leftx = -30;
    } else if (version == this.OfficeVersion.v2013) {
      leftx = -25;
    }
    if (!isSeal) {
      topx = 0;
      leftx = 0;
    }
    var isFloat = true;
    var relative = 1;//1：光标位置；2：页边距；3：页面距离 4：默认设置栏
    var zorder = 0  //0：下方；1：上方。

    if (typeof (top) == "number") {
      topx = top;
    }
    if (typeof(left) == "number") {
      leftx = left;
    }
    if (isSeal) {
      var shapes = this.ocx.ActiveDocument.Shapes;
      var count = shapes.Count;
      var names = []; //遍历出所有图形的名称
      for (var i = 1; i <= count; i++) {
        var shape = shapes.Item(i);
        names.push(shape.Name);
      }
      try {
        this.ocx.AddPicFromURL(url, true, leftx, topx, 1, 100, 0, true);
      } catch (e) {
        this.error("添加图片错误:" + url);
      }
      count = shapes.Count;
      for (var i = 1; i <= count; i++) {
        var shape = shapes.Item(i);
        if (!$.inArray(shape.Name, names)) { //如图形id不在ids数组内则说明是新加的印章图片,给加上标识
          shape.Name = "seal" + shape.Name;
          shape.AlternativeText = 'seal';
        }
      }
    } else {
      try {
        this.ocx.AddPicFromURL(url, false, leftx, topx, 1, 100, 1);
      } catch (e) {
        this.error("添加图片错误:" + url);
      }
    }

    // this.ocx.AddPicFromURL(url, isFloat, leftx, topx, relative, 100, zorder, true);
  }


  resolveTags(str) {
    this.log(str);
    var arr = str.split("");
    var step = [];
    var str = "";
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == "[" && !str.substr(0, 1) != "[") {
        if (str) {
          step.push(str);
        }
        str = "";
      }
      str += arr[i];
      if (arr[i] == "]" && str.substr(0, 1) == "[") {
        if (str) {
          step.push(str);
        }
        str = "";
      }
      if ((i == arr.length - 1) && str) {
        step.push(str);
      }
    }
    return step;
  }

  appendContent(st, yj, cfg, isReturnStr) {
    this.log(st + " ==> " + JSON.stringify(yj));
    var me = this;
    yj = yj || {};
    var userName = yj.creator || yj.assigneeName || "";
    var message = yj.content || "";
    var createTime = yj.createTime || "";
    var value = "";
    var userId = yj.creatorId || yj.assignee;

    function getProp(str) {
      str = str || "";
      str = str.replace("\[", "").replace("\]", "");
      var arr = str.split("#");
      if (arr.length > 1 && arr[1]) {
        return arr[1];
      }
      return "";
    }

    switch (true) {
      case /\[办理人.*\]/.test(st) || /\[电子签名\]/.test(st):
        var prop = getProp(st);
        if (prop) {
          value = userName;
        } else {
          //todo cyy 电子签名 待处理
          debugger
          var imgUrl = me.checkUserSignature(userId);
          if (imgUrl && !isReturnStr) {
            try {
              me.addPicFromUrl(imgUrl);
            } catch (e) {
              value = userName;
            }
          } else {
            value = userName;
          }
        }
        break;
      case "[办理意见]" == st:
        value = message;
        break;
      case /\[意见时间.*\]/.test(st) || /\[意见日期.*\]/.test(st):
        var formatStr = getProp(st) || "yyyy年M月d日";
        if (createTime) {
          value = me.formatDateStr(formatStr, createTime);
        }
        break;
      case "[办理部门]" == st:
        value = yj.department;
        break;
      case "[换行]" == st:
        if (isReturnStr) {
          value = "\n";
        } else {
          me.nextLine();
        }
        break;
      case "[居右]" == st:
        if (!isReturnStr) me.alignRight();
        break;
      case "[居中]" == st:
        if (!isReturnStr) me.alignCenter();
        break;
      case "[居左]" == st:
        if (!isReturnStr) me.alignLeft();
        break;
      default:
        value = st;
        break;
    }

    if (value && !isReturnStr) {
      me.addText(value);
    } else {
      return value;
    }
  }


  setLabelValue(formatObject, formData, businessId, processDefinitionId) {
    var me = this;
    var saveParams = me.saveParams || {};

    var htLabel = formatObject.htLabelName;  //红头书签
    var ffbmLabel = formatObject.ffbmLabelName;  //封发部门
    var htValue = formatObject.htLabelValue;  //红头取值
    var ffbmValue = formatObject.ffbmLabelValue;  //封发部门取值
    //给红头赋值  me.formData：表单的值
    if (htLabel && htValue) {
      htValue = me._eval(formData, htValue);

      if (me.hasBookMark(htLabel)) {
        me.setBookMarkValue(htLabel, htValue);
        try {
          me.fitWidth(htLabel, htValue);
        } catch (e) {
          me.log()
        }
      }
    }
    //给封发部门赋值
    if (ffbmLabel && ffbmValue) {
      ffbmValue = me._eval(formData, ffbmValue)
      formData[ffbmLabel] = ffbmValue;
      if (me.hasBookMark(ffbmLabel)) {
        me.setBookMarkValue(ffbmLabel, ffbmValue);
      }
    }


    var names = this.getBookMarksName();
    $.each(names, function (i, bkName) {
      if (!me.hasBookMark(bkName)) return;
      var bkObj = formatObject.tmplListObject[bkName];

      if (bkName == "fldfj") {
        var params = {
          businessId: me.businessId || saveParams.businessId || "",
          tempBusinessId: me.tempBusinessId || saveParams.tempBusinessId || "",
          formId: me.formId || saveParams.formId || "",
          type: "JOA_FJ"
        }
        MW.mwApi.business.listAttachment(params).then(function (res) {
          var fjStr = "";
          if (res && res.result) {
            var list = res.result;
            $.each(list, function (idx, fj) {
              fjStr += (list.length > 1 ? (idx + 1) + "." : "") + me.getBaseName(fj.name) + (idx == list.length - 1 ? "" : "\r");
            })
          }
          me.setBookMarkValue(bkName, fjStr);
        })
      } else if (bkObj) {
        let valueFrom = bkObj['fldqzfs']; //书签配置取值方式
        let formula = $.trim(bkObj['fldqz']); //这里有可能是表单域或者表达式
        let hqName = bkObj['huiqian']; //获取所有的会签书签
        let yiName = bkObj["fldyjgs"]; //意见格式
        let isSetBMarkValue = true;
        let oldValue = me.getBookMarkValue(bkName);
        let value = "";
        if (valueFrom == "表单域值") {
          value = formData[formula] || "";
          me.setBookMarkValue(bkName, value);
        } else if (valueFrom == "取值表达式") {
          value = me._eval(formData, formula || "");
          me.setBookMarkValue(bkName, value);
        } else if (valueFrom == "按意见类型取值" || valueFrom == "按环节名称取值") {
          var regx = /\[(居(中|左|右)|电子签名)\]/;
          var p = {
            businessId: businessId,
            processDefinitionId: processDefinitionId
          }
          if (valueFrom == "按环节名称取值") {
            p.taskName = formula;
          }
          else {
            p.category = formula;
          }
          MW.mwApi.business.queryCommentProcess(p).then(function (r) {
            if (!r || !r.result) {
              return;
            }
            var yjs = r.result || [];
            if (bkObj.fldfhzxyt == "是") {
              yjs = yjs.length > 0 ? [yjs[yjs.length - 1]] : [];
            }
            if (regx.test(yiName)) {
              me.selectBookMark(bkName);
              var tags = me.resolveTags(yiName);
              $.each(yjs, function (ii, yj) {
                if (tags) {
                  $.each(tags, function (index, el) {
                    me.appendContent(el, yj, {});
                  })
                  if (ii != yjs.length - 1) me.nextLine();
                }
              })
            } else {
              var tags = me.resolveTags(yiName);
              $.each(yjs, function (ii, yj) {
                if (tags) {
                  $.each(tags, function (index, el) {
                    value += me.appendContent(el, yj, {}, true);
                  })
                  if (ii != yjs.length - 1) value += "\n";
                }
              })
              me.setBookMarkValue(bkName, value);
            }
          })
        } else if (valueFrom == "办理过程") {
          MW.mwApi.process.getFlowProcess({businessId: businessId, type: 1}).then(function (v) {
            if (v && v.result && v.result.length > 0) {
              var list = v.result;
              var processValue = "";
              for (var m = 0; m < list.length; m++) {
                var processData = list[m];
                var processDate = me.formatDateStr("yyyy年M月d日", processData.createTime);
                var processComment = processData.comment || "";
                processValue += (m + 1).toString() + ":";
                processValue += processData.name + "    " + processData.department + "    " + processDate + "    " + processComment;
                if (m < list.length - 1) processValue += "\n";
              }
              me.setBookMarkValue(bkName, processValue);
            }
          })
        } else if (valueFrom == "动态表格") {

          //获取表单上的动态表格
          //获取表格数据,暂时打印只有列名称的,合并的那种暂时做不到
          if (!me.form) return;
          if (!me.form.find(formula)) return;
          let tableConfig = me.form.find(formula).getDD();
          if (!tableConfig) return;
          let columnsWidth = tableConfig.columnsWidth;  //数组，每一列的宽度
          let fieldNames = tableConfig.fieldNames;  //返回所有的列域名，第一行也返回了
          let tableValue = tableConfig.value || me.form.find(formula).getValue();  //数据
          let row = tableValue.length + 1;  //行数
          let col = columnsWidth.length; //列数
          let table;
          let valueList = tableConfig.value || me.form.find(formula).getValue(); //所有的数值
          // me.unProtect();
          if (me.hasBookMark(bkName)) {
            //创建表格
            me.selectBookMark(bkName);
            let range = me.ocx.activedocument.application.Selection.Range;
            table = me.ocx.activedocument.Tables.Add(range, row, col, 1, 0);
            //往表格中填入数据
            table.Range.cells.VerticalAlignment = 1;
            var rowCount = table.Rows.Count;
            table.Range.ParagraphFormat.Alignment = 1;
            //写入数据，以列数为准，返回数据
            let title = []; //["标题一","标题二","标题三"]; //第一行的值
            let field = []; //["fldmc","fldname","fldvalue"]; //字段域组合
            let items = tableConfig.items;
            let count = 0;
            if (!items) return;
            //获取第一行的数据以及表格的表达式
            items.map(function (currentValue, index, arr) {
              let colSpan = currentValue.colSpan;
              let itemList = currentValue.items;
              let itemText = "";
              if (itemList && itemList.length > 0) {
                itemList.map(function (item, i, v) {
                  let xtype = item.xtype;
                  if (xtype == "Label") {
                    if (!itemText) {
                      itemText += "'" + item.value + "'";
                    } else {
                      itemText += "+" + "'" + item.value + "'";
                    }
                  } else {
                    if (!itemText) {
                      itemText = item.name;
                    } else {
                      itemText += "+" + item.name;
                    }
                  }
                })
              }
              count = count + colSpan;
              if (count > col) {
                itemText = itemText;
                field.push(itemText);
              } else {
                itemText = itemText + "#" + colSpan.toString();
                itemText = itemText || "";
                itemText.replace(/'/g, "");
                title.push(itemText);
              }
            })

            //写入第一行数据
            for (var i = 0; i < title.length; i++) {
              let titleName = title[i].indexOf("#") != -1 ? title[i].split("#")[0] : "";  //title的值
              let titleColspan = title[i].indexOf("#") != -1 ? title[i].split("#")[1] : 1;  //合并单元格时候用
              if (titleName) {
                titleName = titleName.replace(/'/g, "");
              }
              table.cell(1, i + 1).range.font.size = 12;
              table.cell(1, i + 1).Range.Text = titleName;
              table.cell(1, i + 1).Range.Font.Bold = true;
              table.cell(1, i + 1).Range.Font.Color = 8210719;
            }
            //从第二行开始填入数据
            var rowNum = 2;
            for (var n = 0; n < valueList.length; n++) {
              let v = valueList[n];
              for (var m = 0; m < col; m++) {
                let fieldName = field[m];
                let fieldValue = me._eval(v, fieldName) || "";//new ExprEvaluator(v);
                //获取对应值
                table.cell(rowNum + n, m + 1).range.font.size = 12;
                table.cell(rowNum + n, m + 1).Range.Text = fieldValue;
              }
            }
          }
        }
      }
    })
  }

  checkUserSignature(userId) {
    // var ret= this.query(this.httpPath+PF.url("/api/org/getUser"),{})
    // var params = {
    //   businessId: loginId,
    //   tempBusinessId: loginId,
    //   formId: loginId,
    // }
    // var url = this.httpPath + PF.url("/api/business/listAttachment");
    // var res = this.query(url, params);
    // if (res && res.result && res.result.length > 0) {
    //   return res.result[0];
    // }
    this.log("userId:" + userId);
    return null;
  }

  querySync(url, data) {
    var me = this;
    var result;
    $.ajax({
      url: url,
      method: "POST",
      data: data,
      async: false,
      success: function (res) {
        result = res;
      }
    })
    return result;
  }

  fitWidth(lblName, str) {
    str = str || "";
    var ps = this.ocx.ActiveDocument.Application.Selection.PageSetup;
    var contentWidth = ps.PageWidth - ps.Leftmargin - ps.Rightmargin;//计算正文区域宽度
    var len = str.length - str.replace(/\w/g, "").length;//计算字母
    if (len > 0) {
      len = Math.floor(len / 2);
    }
    len = str.length - len;
    if (this.hasBookMark(lblName)) {
      var fontSize = this.ocx.ActiveDocument.BookMarks(lblName).Range.Font.Size;//字体大小
      var count = contentWidth / fontSize;
      count = Math.floor(count);//每行最多几个汉字
      var scale = Math.ceil(count * 100 / len);//缩放比例
      this.ocx.ActiveDocument.BookMarks(lblName).Range.Font.Scaling = scale;
      this.log(lblName + " scale: " + scale)
    }
  }


  //=======================================================================================================================================
  getOfdTpl() {
    var ocxId = this.ocxId;
    var ocxPath = this.getHttpPath() + "/assets/ntkooledocall/suwellreaderpro-2.0.18.0504-setup-a.exe" || this.ofdOcxPath;
    var tpl = `<object width="100%" height="100%" id="${ocxId}" classid="CLSID:C7F277DC-6C47-AB2C-FB6A-070DC8BE7533">
            <PARAM NAME="modal" VALUE="0">
            <PARAM NAME="enabled" VALUE="-1">
            <span><a href="${ocxPath}">安装OFD插件</a></span>
            </object>`
    return tpl;
  }

  openOfdDocument(openParams) {
    var url;
    if (typeof(openParams) == "string") {
      url = openParams;
    } else {
      var openParams = openParams || this.openParams || {};
      var fileId = openParams.fileId || this.fileId || "";
      var formId = openParams.formId || "";
      var businessId = openParams.businessId || "";
      var tempBusinessId = openParams.tempBusinessId || "";
      var xToken = openParams.xToken || this.xToken || "";
      var url = this.downloadUrl + "?id=" + fileId + "&formId=" + formId + "&businessId=" + businessId + "&xToken=" + xToken;
      url += "&tempBusinessId=" + tempBusinessId;
    }
    this.log(url);
    return this.ocx.openFile2(url, false);
  }

  saveOfd(url) {
    this.ocx.saveFile(url);
  }

}



// WEBPACK FOOTER //
// ./src/common/components/extend/ntko/src/ntko-func-extend.js